export default __webpack_public_path__ + "static/media/l17.7f9e5c87.jpg";